import React, { useState, useEffect } from "react";
import { Tabs, Tab, Card, Row, Col, Button, Table, ProgressBar, Image, Container, Form, Badge, Alert, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { translate, t } from "react-multi-lang";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchVideoEarnings,
  fetchTipEarnings,
  fetchSubsEarnings,
  fetchPaidPostEarnings,
  fetchLiveStreamEarnings
} from "../../store/actions/CreatorEarningsActions";
import "./CreatorDashboard.css";

const CreatorDashboard = () => {
  const dispatch = useDispatch();
  const { video, tips, subs, posts, live_streams, loading } = useSelector((state) => {
    return state.earnings
  });
  const [key, setKey] = useState("video_post_earnings");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [tipStartDate, setTipStartDate] = useState("");
  const [tipEndDate, setTipEndDate] = useState("");
  const [subStartDate, setSubStartDate] = useState("");
  const [subEndDate, setSubEndDate] = useState("");
  const [postStartDate, setPostStartDate] = useState("");
  const [postEndDate, setPostEndDate] = useState("");
  const [liveStreamStartDate, setLiveStreamStartDate] = useState("");
  const [liveStreamEndDate, setLiveStreamEndDate] = useState("");

  useEffect(() => {
    dispatch(fetchVideoEarnings({}));
    dispatch(fetchTipEarnings({}));
    dispatch(fetchSubsEarnings({}));
    dispatch(fetchPaidPostEarnings({}));
    dispatch(fetchLiveStreamEarnings({}))
  }, [dispatch]);

  // ================= FILTER HANDLERS =================
  const handleVideoFilter = () => {
    dispatch(fetchVideoEarnings({ start_date: startDate, end_date: endDate }));
  };

  const handleTipFilter = () => {
    dispatch(fetchTipEarnings({ start_date: tipStartDate, end_date: tipEndDate }));
  };

  const handleSubsFilter = () => {
    dispatch(fetchSubsEarnings({ start_date: subStartDate, end_date: subEndDate }));
  };

  const handlePostFilter = () => {
    dispatch(fetchPaidPostEarnings({ start_date: postStartDate, end_date: postEndDate }));
  };

  const handleLiveStreamsFilter = () => {
    dispatch(fetchLiveStreamEarnings({ start_date: liveStreamStartDate, end_date: liveStreamEndDate }));
  };

  const truncateText = (text, limit = 50) => {
    if (!text) return "";

    const words = text.split(" ");

    if (words.length <= limit) return text;

    return words.slice(0, limit).join(" ") + "...";
  };

  const summaryCard = (title, value, subtitle, variant) => (
    <Card className="shadow mb-5">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <div className="text-muted mb-2">{title}</div>
            <h4 className="mb-0">{value}</h4>
            <small className="text-muted">{subtitle}</small>
          </div>
          <div
            style={{
              width: 45,
              height: 45,
              borderRadius: 10,
              background: variant,
            }}
          />
        </div>
      </Card.Body>
    </Card>
  );

  return (
    <div className="notification-page">
      <Container>
        <div className="profile-post-area">
          <div className="bookmarkes-list bookmarks-right-side resp-sapce-center">
            <div className="pull-left">
              <Link className="bookmarkes-list notify-title" to={`/home`}>
                <Image
                  src="/assets/images/icons/back.svg"
                  className="svg-clone mr-2"
                />
                {t("creator_dashboard")}
              </Link>
            </div>
          </div>
        </div>

        <Tabs
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
        >

          {/* ================= POST VIDEO TAB ================= */}
          <Tab eventKey="video_post_earnings" title="Video Post Earnings" className="mb-5">
            <Row>
              <Col sm={6} md={9} lg={9} xl={8}>
                <Alert variant="warning" className="h4 m-1">
                  Only video posts are eligible for earnings.
                </Alert>
              </Col>
              <Col sm={6} md={3} lg={3} xl={4}>
                <Badge bg="success" className="badge badge-success align-center">
                  <h4 className="align-middle m-1">
                    Rate: ${video?.rate_per_view} per view</h4>
                </Badge>
              </Col>
            </Row>
            <Row className="mt-5 mb-5">
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    className="form-control"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    className="form-control"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Button
                  type="submit"
                  className="post-btn btn-primary" onClick={handleVideoFilter}>Filter</Button>
              </Col>
            </Row>

            <Row>
              <Col md={4} sm={12}>
                {summaryCard("Total Earnings", `$${video?.total_earnings || 0.00}`, (startDate == "") ? "" : "", "#e3f2fd")}
              </Col>
            </Row>

            <Card className="shadow">
              <Card.Body>
                <h5>Video Post Earnings Summary</h5>
                {loading ? (
                  <Spinner animation="border" />
                ) : (
                  <Table hover responsive>
                    <thead>
                      <tr>
                        <th>Post Thumbnail/Image</th>
                        <th>Post Content</th>
                        <th>Views</th>
                        <th>Earnings</th>
                      </tr>
                    </thead>
                    <tbody>
                      {video?.posts?.length > 0 ? (
                        video.posts.map((post) => (
                          <tr key={post.id}>
                            <td>
                              <Image src={post.preview_file} width="80" />
                            </td>
                            <td className="align-middle">{truncateText(post.content, 10)}</td>
                            <td className="align-middle">{post.total_views}</td>
                            <td className="align-middle">${post.earning}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>)}
              </Card.Body>
            </Card>
          </Tab>

          {/* ================= PAID POST TAB ================= */}
          <Tab eventKey="paid_post_earnings" title="Paid Post Earnings" className="mb-5">
            <Row className="mt-5 mb-5">
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    className="form-control"
                    value={postStartDate}
                    onChange={(e) => setPostStartDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    className="form-control"
                    value={postEndDate}
                    onChange={(e) => setPostEndDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Button
                  type="submit"
                  className="post-btn btn-primary" onClick={handlePostFilter}>Filter</Button>
              </Col>
            </Row>

            <Row>
              <Col md={4} sm={12}>
                {summaryCard("Total Earnings", `$${posts?.total_earnings || 0.00}`, (postStartDate == "") ? "" : "", "#e3f2fd")}
              </Col>
            </Row>

            <Card className="shadow">
              <Card.Body>
                <h5>Post Earnings Summary</h5>
                {loading ? (
                  <Spinner animation="border" />
                ) : (
                  <Table hover responsive>
                    <thead>
                      <tr>
                        <th>Post Thumbnail/Image</th>
                        <th>Post Content</th>
                        <th>Amount</th>
                        <th>Earnings</th>
                        <th>Service Fee</th>
                      </tr>
                    </thead>
                    <tbody>
                      {posts?.posts?.length > 0 ? (
                        posts?.posts?.map((post) => (
                          <tr key={post.id}>
                            <td>
                              <Image src={post.preview_file} width="80" />
                            </td>
                            <td className="align-middle content-cell">{truncateText(post.content, 10)}</td>
                            <td className="align-middle">${post.amount}</td>
                            <td className="align-middle">${post.earning}</td>
                            <td className="align-middle">${post.service_fee}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>)}
              </Card.Body>
            </Card>
          </Tab>

          {/* ================= TIP TAB ================= */}

          <Tab eventKey="tips" title="Tip Earnings" className="mb-5">
            <Row className="mt-5 mb-5">
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    className="form-control"
                    value={tipStartDate}
                    onChange={(e) => setTipStartDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    className="form-control"
                    value={tipEndDate}
                    onChange={(e) => setTipEndDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Button
                  type="submit"
                  className="post-btn btn-primary" onClick={handleTipFilter}>Filter</Button>
              </Col>
            </Row>

            <Row>
              <Col md={4} sm={12}>
                {summaryCard("Total Tips Received", `$${tips?.total_tips_received || 0}`, (tipStartDate == "") ? "" : "", "#e3f2fd")}
              </Col>
            </Row>

            <Card className="shadow ">
              <Card.Body>
                <h5>Tips Earnings Summary</h5>
                {loading ? (
                  <Spinner animation="border" />
                ) : (
                  <Table hover responsive>
                    <thead>
                      <tr>
                        <th>User</th>
                        <th>Amount</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tips?.tips?.data?.length > 0 ? (
                        tips?.tips?.data.map((tip) => (
                          <tr key={tip.id}>
                            <td>{tip.fromusername}</td>
                            <td>${tip.tip_amount}</td>
                            <td>{tip.paid_date}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                )}
              </Card.Body>
            </Card>
          </Tab>

          {/* ================= SUBSCRIPTION TAB ================= */}

          <Tab eventKey="subs" title="Subscription Earnings" className="mb-5">

            <Row className="mt-5 mb-5">
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    className="form-control"
                    value={subStartDate}
                    onChange={(e) => setSubStartDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    className="form-control"
                    value={subEndDate}
                    onChange={(e) => setSubEndDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Button
                  type="submit"
                  className="post-btn btn-primary" onClick={handleSubsFilter}>Filter</Button>
              </Col>
            </Row>

            <Row>
              <Col md={4} sm={12}>
                {summaryCard("Active Subscribers", subs?.active_subscribers || 0, "", "#fff3e0")}
              </Col>
              <Col md={4} sm={12}>
                {summaryCard("Subscription Revenue", `$${subs?.total_revenue || 0}`, (subStartDate == "") ? "" : "", "#f3e5f5")}
              </Col>
            </Row>

            <Card className="shadow ">
              <Card.Body>
                <h5>Subscription Earning Summary</h5>
                <Table hover responsive>
                  <thead>
                    <tr>
                      <th>User</th>
                      <th>Amount</th>
                      <th>Service Fee</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {subs?.subscriptions?.data?.length > 0 ? (
                      subs?.subscriptions?.data?.map((sub) => (
                        <tr key={sub.id}>
                          <td>{sub.from_username}</td>
                          <td>${sub.user_amount}</td>
                          <td>${sub.admin_amount}</td>
                          <td>{sub.paid_date}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Tab>

          {/* ================= LIVESTREAM TAB ================= */}

          <Tab eventKey="livestream_earnings" title="LiveStream Earnings" className="mb-5">

            <Row className="mt-5 mb-5">
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    className="form-control"
                    value={liveStreamStartDate}
                    onChange={(e) => setLiveStreamStartDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    className="form-control"
                    value={liveStreamEndDate}
                    onChange={(e) => setLiveStreamEndDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Button
                  type="submit"
                  className="post-btn btn-primary" onClick={handleLiveStreamsFilter}>Filter</Button>
              </Col>
            </Row>

            <Row>
              <Col md={4} sm={12}>
                {summaryCard("LiveStream Revenue", `$${live_streams?.total_earnings || 0.00}`, (liveStreamStartDate == "") ? "" : "", "#f3e5f5")}
              </Col>
            </Row>

            <Card className="shadow ">
              <Card.Body>
                <h5>LiveStream Earnings Summary</h5>
                <Table hover responsive>
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Amount</th>
                      <th>Earnings</th>
                      <th>Service Fee</th>
                    </tr>
                  </thead>
                  <tbody>
                    {live_streams?.live_streams?.length > 0 ? (
                      live_streams?.live_streams?.map((live_stream) => (
                        <tr key={live_stream.id}>
                          <td>${live_stream.title}</td>
                          <td>${live_stream.amount}</td>
                          <td>${live_stream.earning}</td>
                          <td>${live_stream.service_fee}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Tab>
        </Tabs>

      </Container>
    </div>
  );
}

export default CreatorDashboard;